import { render } from "./author-identity.vue?vue&type=template&id=245418ad&scoped=true"
import script from "./author-identity.vue?vue&type=script&lang=js"
export * from "./author-identity.vue?vue&type=script&lang=js"

import "./author-identity.vue?vue&type=style&index=0&id=245418ad&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245418ad"]])

export default __exports__